import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    forwardRef,
    Inject,

    OnInit,
    Optional,
    ViewEncapsulation
} from '@angular/core';
import { FormBuilder, FormGroup, } from '@angular/forms';
import { buildProviders } from '@kalidea/kaligraphi';
import { Store } from '@ngxs/store';
import gql from 'graphql-tag';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import {
    FolderBankListComponent
} from 'src/app/_shared/dialogs/folder-bank-dialog/folder-bank-list/folder-bank-list.component';
import { MutationGetInitialisationAdmninistrationAlbumsArgs, PortailStatutDto } from 'src/graphql/generated-types';

export interface FolderBankFilters {
    statusId?: number;
    hasExpired?: boolean;
    isUnlinked?: boolean;
}

@Component({
    selector: 'app-folder-bank-filters',
    templateUrl: './folder-bank-filters.component.html',
    styleUrls: ['./folder-bank-filters.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(FolderBankFiltersComponent),
    standalone: false
})
export class FolderBankFiltersComponent extends CustomFormControlAccess implements OnInit {

    loading = false;

    statusList: PortailStatutDto[] = [];

    form: FormGroup;

    constructor(@Optional() @Inject(forwardRef(() => FolderBankListComponent)) private folderListComponent: FolderBankListComponent,
                private graphqlService: GraphqlService,
                private store: Store,
                private fb: FormBuilder,
                private cdr: ChangeDetectorRef) {
        super();
    }

    writeValue(value: any): void {
        super.writeValue(value);
        this.form.patchValue(value, {emitEvent: false});
        this.cdr.markForCheck();
    }

    applyFilters(): void {
        super.notifyUpdate(this.form.value);
        this.closeFilters();
    }

    closeFilters(): void {
        this.folderListComponent.toggleFilters();
    }

    private initFilters(): void {
        this.loading = true;
        this.cdr.markForCheck();

        this.graphqlService.mutateOne<'getInitialisationAdmninistrationAlbums', MutationGetInitialisationAdmninistrationAlbumsArgs>({
            mutation: gql`
                mutation getInitialisationAdmninistrationAlbums($contexte: ContextInfosInput) {
                    getInitialisationAdmninistrationAlbums(contexte: $contexte) {
                        ListeStatut{
                            PortailStatutDTO{
                                Id
                                Code
                                Libelle
                            }
                        }
                    }
                }
            `,
        })
            .pipe(
                this.untilDestroyed,
                tap((getInitialisationAdmninistrationAlbums) => {
                    this.statusList = getInitialisationAdmninistrationAlbums?.ListeStatut?.PortailStatutDTO || [];

                    this.loading = false;
                    this.cdr.markForCheck();
                }),
                catchError(err => {
                    this.loading = false;
                    this.cdr.markForCheck();
                    return throwError(err);
                }),
            ).subscribe();
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            statusId: [null],
            hasExpired: false,
            isUnlinked: false
        });

        this.initFilters();
    }

}
